import {
  ContentAudience,
  ContentWorkflow,
  WorkflowState,
  WorkflowSteps,
  WorkflowStateToSteps,
  PastTenseCurrentStateLabel,
  WorkflowStepsCurrentStateLabel,
} from '@amzn/awscat-pattern-library-service-model';

export const WorkflowStepsToolTipLabel = new Map([
  [WorkflowSteps.Draft, 'draft.'],
  [WorkflowSteps.Peer, 'peer review.'],
  [WorkflowSteps.QualityCheck, 'quality check.'],
  [WorkflowSteps.Publisher, 'publisher review.'],
  [
    WorkflowSteps.Rejected,
    'Rejected. Contact reviewer for feedback, revise, and resubmit for approval.',
  ],
  [WorkflowSteps.Internal, 'publish internally.'],
  [
    WorkflowSteps.Unpublished,
    "Unpublished. Content isn't useful or valid. Contact the publisher for details, revise, and resubmit for approval.",
  ],
  [WorkflowSteps.TechwriterPool, 'APG selection pool.'],
  [WorkflowSteps.TechwriterReview, 'tech writer review.'],
  [WorkflowSteps.External, 'publish to APG Library.'],
  [WorkflowSteps.Public, 'publish to APG public website.'],
  [WorkflowSteps.Revoked, 'Removed from the APG public website.'],
]);

export const PastTenseToolTipLabel = new Map([
  [WorkflowSteps.Internal, 'Published internally.'],
  [WorkflowSteps.External, 'Published to APG Library.'],
  [WorkflowSteps.Public, 'Published to APG public website.'],
]);

export enum Prefix {
  Completed = 'Completed',
  Currently = 'Currently in',
  Next = 'Next step is',
  Upcoming = 'Upcoming step is',
  Final = 'Final step is',
}

export enum Svg {
  Completed = 'Completed',
  Current = 'Current',
  Rejected = 'Rejected',
  Upcoming = 'Upcoming',
  Final = 'Final',
}

export const getCurrentContentState = (workflow: ContentWorkflow): WorkflowState => {
  const { draftState, publicationState } = workflow;
  const currentState = draftState === WorkflowState.UNMODIFIED ? publicationState : draftState;
  // @ts-expect-error TS2322 - strict migration
  return currentState;
};

export const determineProgress = (i: ContentWorkflow) => {
  const { contentAudience, skipDraftReview, techWriterId } = i;
  const currentState = getCurrentContentState(i);
  let workflowStep = WorkflowStateToSteps.get(currentState);
  if (
    currentState === WorkflowState.PUBLISHED &&
    contentAudience !== ContentAudience.INTERNAL &&
    contentAudience !== ContentAudience.EXTERNAL &&
    contentAudience !== ContentAudience.PARTNER
  ) {
    if (techWriterId) {
      workflowStep = WorkflowSteps.TechwriterReview;
    } else {
      workflowStep = WorkflowSteps.TechwriterPool;
    }
  }
  let progressLabel = '';
  if (
    // @ts-expect-error TS2345 - strict migration
    [WorkflowSteps.Internal, WorkflowSteps.External, WorkflowSteps.Public].includes(workflowStep)
  ) {
    // @ts-expect-error TS2322 - strict migration
    progressLabel = PastTenseCurrentStateLabel.get(workflowStep);
  } else if (
    // @ts-expect-error TS2345 - strict migration
    [WorkflowSteps.TechwriterPool, WorkflowSteps.TechwriterReview].includes(workflowStep) &&
    skipDraftReview
  ) {
    // @ts-expect-error TS2322 - strict migration
    progressLabel = WorkflowStepsCurrentStateLabel.get(WorkflowSteps.SendBackToAuthor);
  } else {
    // @ts-expect-error TS2322 - strict migration
    progressLabel = WorkflowStepsCurrentStateLabel.get(workflowStep);
  }
  return progressLabel;
};
